import React, { Component } from 'react'

export default class ChatBotFlowCard extends Component {
    render() {
        return (
            <div className="card-form w-full shadow-md rounded-lg">
                <div className="card-title text-center p-6 text-xl text-white bg-olddarkblue font-bold rounded-t-lg">{this.props.title}</div>
                <div className="card-body bg-white p-6 rounded-b-lg border border-gray-300" style={this.props.cardBodyStyles}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
